import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { dominioEscritorioBeneficiosContratacao, dominioEscritorioBeneficiosContratacaoWebp, dominioEscritorioBeneficiosConvite, dominioEscritorioBeneficiosConviteWebp, dominioEscritorioContabilidadeContratacao, dominioEscritorioContabilidadeContratacaoWebp, dominioEscritorioContabilidadeConvite, dominioEscritorioContabilidadeConviteWebp, dominioEscritorioContaPjContratacao, dominioEscritorioContaPjContratacaoWebp, dominioEscritorioContaPjConvite, dominioEscritorioContaPjConviteWebp, } from '@ibk/shared-assets';
import { ApiProductStatus, ProductAlias } from '@ibk/shared-types';
const CONTA_PJ_SUPPORT_URL = 'https://suporte.dominioatendimento.com/servicos-digitais/faces/servicos-digitais-escritorio.html';
const createContaPjBanner = (isContracted) => ({
    id: isContracted ? 'conta-pj-convite' : 'conta-pj-contratacao',
    image: isContracted ? dominioEscritorioContaPjConvite : dominioEscritorioContaPjContratacao,
    webpImage: isContracted ? dominioEscritorioContaPjConviteWebp : dominioEscritorioContaPjContratacaoWebp,
    type: isContracted ? 'convite' : 'contratacao',
    onClick: () => {
        window.open(CONTA_PJ_SUPPORT_URL, '_blank', 'noopener,noreferrer');
    },
});
const createProductBanner = (productAlias, isContracted, contractedImage, contractedWebpImage, nonContractedImage, nonContractedWebpImage, navigate) => {
    let onClick;
    if (productAlias === ProductAlias.BENEFICIOS) {
        onClick = () => {
            if (isContracted) {
                window.open('https://suporte.dominioatendimento.com/servicos-digitais/faces/servicos-digitais-cliente.html', '_blank', 'noopener,noreferrer');
            }
            else {
                navigate('/beneficios');
            }
        };
    }
    if (productAlias === ProductAlias.CONTABILIDADE_DIGITAL) {
        onClick = () => {
            const url = isContracted
                ? 'https://onvio.com.br/staff/#/loopback?path=%2fservicos-digitais%2ffaces%2fconvite-dominio-contabilidade-digital.html%3FidContratacao%3D4'
                : 'https://onvio.com.br/staff/#/loopback?path=%2fcontratacao%2ffaces%2fdominio-contabilidade-digital.html%3FidContratacao%3D2';
            window.open(url, '_blank', 'noopener,noreferrer');
        };
    }
    return {
        id: isContracted ? `${productAlias.toLowerCase()}-convite` : `${productAlias.toLowerCase()}-contratacao`,
        image: isContracted ? contractedImage : nonContractedImage,
        webpImage: isContracted ? contractedWebpImage : nonContractedWebpImage,
        type: isContracted ? 'convite' : 'contratacao',
        productAlias,
        onClick,
    };
};
const isProductAvailable = (product) => !product.isLoading && !product.error;
const isProductContracted = (product) => product.data?.status === ApiProductStatus.ACTIVE;
export const useContaPjEscritorioBanners = ({ productsData, isActive = true, }) => {
    const navigate = useNavigate();
    return useMemo(() => {
        if (!isActive) {
            return [];
        }
        const banners = [];
        const { products } = productsData;
        const contaPjProduct = products[ProductAlias.CONTA_DIGITAL];
        if (isProductAvailable(contaPjProduct)) {
            const isContaPjContracted = isProductContracted(contaPjProduct);
            banners.push(createContaPjBanner(isContaPjContracted));
        }
        const beneficiosProduct = products[ProductAlias.BENEFICIOS];
        if (isProductAvailable(beneficiosProduct)) {
            const isBeneficiosContracted = isProductContracted(beneficiosProduct);
            banners.push(createProductBanner(ProductAlias.BENEFICIOS, isBeneficiosContracted, dominioEscritorioBeneficiosConvite, dominioEscritorioBeneficiosConviteWebp, dominioEscritorioBeneficiosContratacao, dominioEscritorioBeneficiosContratacaoWebp, navigate));
        }
        const contabilidadeProduct = products[ProductAlias.CONTABILIDADE_DIGITAL];
        if (isProductAvailable(contabilidadeProduct)) {
            const isContabilidadeContracted = isProductContracted(contabilidadeProduct);
            banners.push(createProductBanner(ProductAlias.CONTABILIDADE_DIGITAL, isContabilidadeContracted, dominioEscritorioContabilidadeConvite, dominioEscritorioContabilidadeConviteWebp, dominioEscritorioContabilidadeContratacao, dominioEscritorioContabilidadeContratacaoWebp, navigate));
        }
        return banners;
    }, [productsData, isActive, navigate]);
};
